import { ENVIRONMENT } from '../constants'

export const getEnvironment = (hostname = window.location.hostname) => {
  const { DEV, LIVE, QA } = ENVIRONMENT;

  if (hostname.includes(DEV)) {
    return DEV;
  }
  if (hostname.includes(QA)) {
    return QA;
  }
  return LIVE;
}


// WEBPACK FOOTER //
// ./src/utils/getEnvironment.js